import { formatNumber } from "../../utils/numbers";
import { FadeContent } from "../common/FadeContent";
function getDisplayRange(totalRecords, pageSize, currentPage, isCondensed = false) {
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalRecords);
  if (isCondensed) {
    return `${start}-${end} of ${formatNumber(totalRecords, 0)}`;
  }
  return `Showing ${start} to ${end} of ${formatNumber(totalRecords, 0)}`;
}

const SearchSummary = ({ isShowing, totalRecords, pageSize, currentPage, isCondensed = false }) => (
  <FadeContent isShowing={isShowing}>
    <p className="text-gray-secondary px-2 leading-[19.2px] font-[400] text-[14px] whitespace-nowrap">
      {getDisplayRange(totalRecords, pageSize, currentPage, isCondensed)}
    </p>
  </FadeContent>
);

export default SearchSummary;
